import styled from 'styled-components';
import { MDBDropdown, MDBDropdownItem } from 'mdbreact';
import { colors, MediaQuery } from '../../theme/style-helpers';
import Column from '../ReactComponent/Column';
import TertiaryButton from '../../lib/ui/buttons/TertiaryButton';
import { P } from '../../theme/typographySitecore';
import ChevronDownOrangeSmall from '../../assets/icons/ChevronDownOrangeSmall.svg';

export const LoginBanner = styled.div`
    height: 168px;
    top: 372px;
    background: red;
`;

export const FieldGroup = styled.div`
    margin-bottom: 58px;
`;

export const ErrorMessage = styled.span`
    font-style: normal;
    padding: 10px 6px;
    align-items: center;
    display: flex;
    font-weight: 500;
    font-size: 1.4rem;
    line-height: normal;
    color:  ${colors.ERROR};
`;

export const Icon = styled.img`
    margin-right: 10px;

    &.right {
        margin-right: 0;
        margin-left: 10px;
    }
`;

export const LogisticsContainer = styled.div`
    display: grid;
    grid-gap: 8px;
    grid-auto-flow: column;
    width: fit-content;
    align-items: center;
    margin: 16px 0px;
`;

export const Label = styled.span`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
`;

export const LogisticsButton = styled(TertiaryButton)`
    padding: 0px;
    text-decoration-line: underline;
    text-underline-offset: 6px;

    p {
        font-weight: 600;
    }
`;

export const FormContainer = styled.div`
    width: 100%;
    margin: 0 auto;
`;

export const AddressBlock = styled.div`
    &.with-bg {
        background-color: ${colors.LIGHT_GREY};
        padding: 32px;
        box-shadow: 0px 32px 6px -30px rgba(0, 0, 0, 0.2);
        border-radius: 6px;
        margin-bottom: 32px;
    }
`;

export const FormSummary = styled.summary`
    margin: 32px 0 72px;
`;

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 72px;
`;

export const SuccessMessageBox = styled.div`
    text-align: center;
    margin: 32px auto 100px;

    .success-image {
        margin-bottom: 32px;
    }
`;
export const AddItemContainer = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-end;
    padding: 18px 8px;
    margin-bottom: 40px;
    &.with-background {
        background-color: ${colors.WHITE};
        border-bottom: 1px solid ${colors.COOL_GREY};

        p {
            margin: 0;
        }
    }

    .hide {
        display: none;
    }
`;

export const AddItem = styled.button`
    background-color: ${colors.WHITE};
    font-style: normal;
    position: relative;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: normal;
    text-align: center;
    color: ${colors.DARK_GREY};
    padding: 17px 34px;
    border: 1px solid ${colors.COOL_GREY};
    border-radius: 3px;
    margin-left: 0;
    margin-bottom: 10px;
    width: 100%;
    cursor: pointer;
    order: 0;

    ${MediaQuery.medium`
        width: auto;
        margin-left: 16px;
        margin-bottom: 0;
        order: 1;
    `}

    &.active {
        background-color: ${colors.BLACK};

        label {
            color: ${colors.WHITE};
        }

        &:hover {
            background-color: ${colors.BRAND_ORANGE};
            color: ${colors.BLACK};
            border-color: ${colors.BRAND_ORANGE};
        }
    }

    .hidden-button {
        display: none;
    }
`;

export const AddItemLabel = styled.label`
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 2.2rem;
    color: ${colors.DARK_GREY};
    margin-bottom: 0;
    margin-left: 8px;
    cursor: pointer;
`;

export const AddedItemCard = styled.div`
    background-color: ${colors.LIGHT_GREY};
    padding: 32px;
    box-shadow: 0px 32px 6px -30px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    width: 100%;
    margin: 40px 0;
    position: relative;
    flex-wrap: wrap;

    .row {
        width: 100%;
    }

    .title-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 24px;
        flex-wrap: wrap;

        p {
            margin: 0;
        }

        > &:nth-child(even) {
            background-color: ${colors.WHITE};
        }
    }

    h2, h3 {
        color: ${colors.DARK_GREY};
    }
`;

export const HelpBox = styled.div`
    margin: 10px;
    background: grey;
`;

export const PageTitle = styled.div`
    font-weight: 300;
    font-size: 4.8rem;
    margin-bottom: 32px;

    &.justified {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
`;

export const FieldGroupLabel = styled.h2`
    font-style: normal;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: no-wrap;
    width: 100%;
    margin-bottom: 16px;
`;

export const DisclaimerGroup = styled.div`
    display: flex;
    flex-direction: row;
    align-content: center;
    margin-top: -8px;
    margin-bottom: 16px;
`;

export const DisclaimerNote = styled.h3`
    font-style: normal;
    font-size: 14px;
    color: ${colors.BRAND_ORANGE};
    font-weight: 600;
    line-height: 22px;
    display: flex;
    align-items: center;
    flex-wrap: no-wrap;
    margin: 0;
`;

export const DisclaimerText = styled.p`
    font-style: normal;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    align-items: center;
    flex-wrap: no-wrap;
    margin: 0;
`;

export const BillingAccountsContainer = styled.div`
    display: grid;
    grid-gap: 16px;
`;

export const BillToGuide = styled.div`
    font-size: 1.4rem;
    line-height: 2.2rem;
    padding: 16px;
    h4 {
        font-weight: 700;
        font-size: 1.6rem;
        margin-bottom: 8px;
    }
    p {
        margin: 0;
    }
    dl {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 4px 12px;
        margin: 8px 0 0 0;
    }
    dt {
        white-space: nowrap;
    }
    dd {
        margin: 0;
    }
`;

export const CategoryTitle = styled.div`
    font-size: 2.4rem;
    line-height: 32px;
    margin-top: ${(props) => (props.noMargins ? '0px' : '56px')};
    margin-bottom: ${(props) => (props.noMargins ? '0px' : '32px')};
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
    font-weight: 500;
    font-family: Montserrat;
`;

export const DivisionRow = styled.div`
    margin-bottom: 80px;

    .delivery-type {
        .rw-list {
            margin: 0;
        }

        .rw-select-list-label {
            margin-right: 3rem;
            font-size: 1.4rem;
            line-height: 2.1rem;
            display: inline-flex;
            align-items: center;
            position: relative;
            padding-left: 28px;
            cursor: pointer;
            user-select: none;
            flex-wrap:wrap;

            .rw-select-list-input {
                position: absolute;
                opacity: 0;
                cursor: pointer;
                height: 0;
                width: 0;

                &:checked ~ .checkmark {
                    background-color: ${colors.BRAND_ORANGE};

                    &:after {
                        display: block;
                        left: 5px;
                        top: 1px;
                        width: 7px;
                        height: 11px;
                        border: solid ${colors.WHITE};
                        border-width: 0 2px 2px 0;
                        transform: rotate(45deg);
                    }
                }
            }

            .checkmark {
                position: absolute;
                top: 0;
                left: 0;
                height: 21px;
                width: 21px;
                border: 1.5px solid ${colors.BLACK};
                background-color: ${colors.WHITE};
                border-radius: 2px;

                &:after {
                    content: "";
                    position: absolute;
                    display: none;
                }
            }
        }
    }
`;

export const PaymentMethod = styled.div`
    margin: 56px 0;
`;

export const PaymentMethodsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 24px;
    align-items: flex-start;

    ${MediaQuery.small`
        grid-template-columns: repeat(2, 1fr);
    `};

    ${MediaQuery.medium`
        grid-template-columns: repeat(${({ loggedIn }) => (loggedIn ? 3 : 4)}, 1fr);
    `};
`;

export const InputUnit = styled.div`
    font-size: 18px;
    line-height: 24px;
    margin-top: 45px;
`;

export const MeasurementItemProperty = styled.div`
    height: 56px;
    font-size: 14px;
    line-height: 17px;
`;

export const TextProperty = styled.div`
    font-size:1.4rem;
    margin-bottom: 32px;
    font-weight: 500;

    .title {
        margin-bottom: 10px;
    }

    .justified {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    hr {
        border-color: #000;
        margin: 1.5rem 0 3rem;
    }
`;

export const ContentBoxLightGrey = styled.div`
    background-color: ${colors.LIGHT_GREY};
    padding: 32px;
    box-shadow: 0px 32px 6px -30px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    width: 100%;
    margin: 40px 0;
    position: relative;
    flex-wrap: wrap;

    .title-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 24px;
        flex-wrap: wrap;

        p {
            margin: 0;
        }

        > &:nth-child(even) {
            background-color: ${colors.WHITE};
        }
    }

    h2, h3 {
        color: ${colors.DARK_GREY};
    }
`;

export const EditButtonGroup = styled.div`
    text-align: right;
`;

export const LineButton = styled.a`
    display: inline-flex;
    align-items: center;
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 500;
    cursor: pointer;
    color: ${colors.BLACK};
    text-decoration: none;
    padding: 8px 17px;
`;

export const MeasurementTab = styled.div`
    font-weight: 500;
    font-size: 1.6rem;

    .rw-list-option {
        .rw-select-list-label {
            background-color: ${colors.COOL_GREY};
            border: 1px solid ${colors.BLACK};
            padding: 16px 41px;
            line-height: 1;
            box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.2);
            margin: 0;
            cursor: pointer;

            .rw-select-list-input {
                display: none;
            }
        }

        &[aria-checked="true"] {
            .rw-select-list-label {
                background-color: ${colors.WHITE};
                box-shadow: none;
            }
        }
    }
`;

export const Terms = styled.div`
    margin-bottom: 72px;
`;

export const CheckBox = styled.div`
    .rw-list {
        margin: 0;
    }

    .rw-select-list-label {
        margin-right: 3rem;
        font-size: 1.4rem;
        line-height: 2.1rem;
        display: inline-flex;
        align-items: center;
        position: relative;
        padding-left: 28px;
        cursor: pointer;
        user-select: none;
        flex-wrap:wrap;

        .rw-select-list-input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;

            &:checked ~ .checkmark {
                background-color: ${colors.BRAND_ORANGE};

                &:after {
                    display: block;
                    left: 5px;
                    top: 1px;
                    width: 7px;
                    height: 11px;
                    border: solid ${colors.WHITE};
                    border-width: 0 2px 2px 0;
                    transform: rotate(45deg);
                }
            }
        }

        .checkmark {
            position: absolute;
            top: 0;
            left: 0;
            height: 21px;
            width: 21px;
            border: 1.5px solid ${colors.BLACK};
            background-color: ${colors.WHITE};
            border-radius: 2px;

            &:after {
                content: "";
                position: absolute;
                display: none;
            }
        }
    }
`;

export const ItemContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const FileUploadContainer = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
    padding: 18px 8px;
    order: 99;

    &.with-dot {
        margin-bottom: 57px;
        padding: 0;

        &:after {
            content: '';
            width: calc(100% - 200px);
            background-image: linear-gradient(to right, ${colors.DARK_GREY} 33%, rgba(255,255,255,0) 0%);
            background-position: bottom;
            background-size: 6px 2px;
            background-repeat: repeat-x;
            height: 2px;
        }
    }

    &.with-background {
        background-color: ${colors.WHITE};
        border-bottom: 1px solid ${colors.COOL_GREY};

        p {
            margin: 0;
        }
    }
`;

export const FileUpload = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;

    .hidden-button {
        display: none;
    }
`;

export const FileUploadLabel = styled.label`
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 2.2rem;
    color: ${colors.DARK_GREY};
    margin-bottom: 0;
    margin-left: 8px;
`;

export const ButtonDiv = styled.div`
    padding-top: 40px;
    padding-bottom: 40px;
    padding-left: 0;
`;

export const ModalTitle = styled.div`
    font-size:2.5rem;
    padding-bottom: 25px;
`;

export const ModalBody = styled.div`
    padding: 50px;
    font-size: 1.5rem;
    text-align: center;
`;

export const ModalButtons = styled.div`
    padding-top: 40px;
    justify-content: center;

    button{
        width: 100%;
        div, p {
            white-space: nowrap;
        }
    }
`;

export const DangerousGoodsContainer = styled(Column)`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const CardDescription = styled.p`
  padding: 0 60px;
  font-size: 12px;
  line-height: 20px;
`;

export const UploadedDocumentsSummary = styled(P)`
  margin-bottom: 32px;
`;

export const UploadedDocumentsInformation = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    p {
        margin-bottom: 0px;
    }

    ${Icon} {
        margin-right: 0px;
    }
`;

export const LastActionsContainer = styled.div`
    display: grid;
    grid-gap: 20px;
    grid-auto-flow: column;
    justify-content: flex-end;

    >button:nth-child(1), >button:nth-child(2) {
        width: 100%;
        position: relative;
        font-style: normal;
        font-weight: 500;
        font-size: 1.6rem;
        line-height: normal;
        text-align: center;
        color: ${colors.BLACK};
        background: ${colors.WHITE};
        padding: 16px 24px;
        height: 52px;
        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
            width:${({ msButtonWidth }) => (msButtonWidth || '100%')};
        }
    }
    >button:nth-child(4) {
        height: 52px;
    }


    .dropdown {
        width: 100%;

        .btn {
            width: 100%;
            position: relative;
            font-style: normal;
            font-weight: 500;
            font-size: 1.6rem;
            line-height: normal;
            text-align: center;
            color: ${colors.BLACK};
            background: ${colors.WHITE};
            white-space: nowrap;
            border: 1px solid ${colors.BLACK};
            border-radius: 1px !important;
            padding: 16px 24px;
            padding-right: 56px;
            border-radius: 3px;
            height: 52px;
            @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
                width:${({ msButtonWidth }) => (msButtonWidth || '100%')};
             }
        }
        .dropdown-menu {
            width: 100%;
            @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
                width:auto;
             }
        }
        .icon {
            position: absolute;
            top: 50%;
            right: 17px;
            transform: translateY(-50%);
            height: 14px;
            width: 14px;
            background-size: cover;
            ${({ iconSrc }) => (iconSrc ? `background: url(${iconSrc})` : '')}
        }

        .icon-more-options {
            background: url(${ChevronDownOrangeSmall});
        }
    }
    & .hideMobile{
        display: none;
        ${MediaQuery.xLarge`
            display: flex;
        `}
    }
    
`;
export const Step5ButtonsRow = styled.div`
    position: relative;
    display: flex;
    justify-content: ${(props) => (props.justifyContent ? props.justifyContent : 'flex-end')};
    align-items: center;
    width: 100%;
    margin-top: ${(props) => (props.showBack ? '32px' : '0px')};
    margin-bottom: ${(props) => (props.showBack ? '40px' : '0px')};

    ${MediaQuery.small`
        margin-top: 0;
    `}

`;

export const Step5Label = styled.div`
    font-family: Montserrat;
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 2.4rem;

    span{
        font-weight: 600;
    }
`;

export const StepPageTitle = styled.p`
    font-size: 24px;
    font-weight: 500;
    line-height: 31px;
    letter-spacing: 0em;
    text-align: left;
    margin: 0px;
`;

export const StepPageSubtitle = styled.p`
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${colors.BLACK};
    margin: 0px;
`;
export const StyledMDBDropdown = styled(MDBDropdown)`
    ${MediaQuery.xLarge`
        display: none;
    `}

    .dropdown-menu {
        padding: 15px;
        background-color: ${colors.LIGHT_GREY} !important;
        cursor: default;

        >div {
            display: grid;
            grid-gap: 24px;
        }
    }
    
`;

export const DropdownItem = styled(MDBDropdownItem)`
    display: flex !important;
    align-items: center !important;
    padding: 0px !important;
    font-size: 14px;
    font-weight: 500 !important;
    line-height: 18px;
    letter-spacing: 0em;
    cursor: pointer;

    &:enabled {
        color: ${colors.BLACK} !important;
    }

    &:disabled {
        color: ${colors.DARK_GREY} !important;
    }

    &:hover {
        path {
            fill: ${colors.BRAND_ORANGE};
        }
        p {
            color: ${colors.BRAND_ORANGE};
        }
    }
`;

export const DropdownItemIcon = styled.div`
    width: 20px;
    height: 20px;
    background: url( ${({ iconSrc }) => iconSrc});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin: 0;
    margin-right: 8px;
`;

export const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 25px;
    svg {
        margin-right: 8px;
    }
`;

export const DropdownText = styled.p`
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0em;
`;

export const ModalBodyAlert = styled.div`
    padding-top: 25px;
    font-size: 1.5rem;
`;

export const CanRateLinkWrapper = styled.div`
  max-width: 1200px;
  margin: -40px -60px 0 0;
  text-align: left;
  a {
    font-size: 15px;
    font-weight: 300;
    text-decoration: underline;
  }
`;
